export const BAC_CDI_LIBRARY = {
  title: {
    ar: 'المكتبة الفرنسية',
    fr: 'Le CDI français',
    en: 'The french Library',
  },
  description: {
    ar: `اللائحة الداخلية للمكتبة الفرنسية (C.D.I):
يمكن للطلاب: 
</br>• القراءة من أجل المتعة: روايات، شعر، مسرحيات، قصص مصورة، أعمال كلاسيكية، إلخ.
</br>• القيام بأعمال بحث باستخدام برنامج البحث الوثائقي والمراجع الوثائقية.
</br>• إنتاج مستندات.
</br>• إثراء ثقافتهم الشخصية بقراءة مستندات ثقافية.
</br>• متابعة الأخبار بقراءة الدوريات، الصحف، ولوحات الإعلانات.
</br>• الاطلاع على المستندات الموجودة واستخدام الأدوات المساعدة: القواميس، الموسوعات الورقية والإلكترونية، الأطالس، الكتب المدرسية.
</br>• زيارة المركز مع معلم ضمن حصة دراسية.
</br>• استخدام الحواسيب للكتابة، أو استخدام الإنترنت في إطار البحث الموجه.
</br>يجب على الطلاب:
</br>• احترام مسئولي المركز.
</br>• عدم الدخول بالحقائب وأخذ الأشياء الضرورية للعمل فقط.
</br>• عدم إحضار المشروبات أو الطعام.
</br>• التسجيل في سجل الحضور.
</br>• أن يكونوا هادئين أو يتحدثون بصوت منخفض.
</br>• الاعتناء بالأثاث والكتب وأدوات المكتبة.
</br>• احترام ترتيب الكتب لأن لكل كناب مكانه الخاص.
</br>• الذهاب إلى مسئول المكان لإرجاع أو استعارة كتاب.
</br>• إعادة ترتيب الكراسي والطاولات قبل المغادرة.
</br>• الاستئذان قبل استخدام الحواسيب.
</br>• التسجيل في سجل استخدام الحواسيب.
</br>• عدم الاطلاع على صناديق البريد، المدونات، مواقع التواصل الاجتماعي أو أي مواقع غير قانونية.
</br>• عدم الدردشة إلا في إطار المحادثات المدرسية.
</br>• عدم اللعب على الحواسيب.
</br>• عدم استخدام الفلاشات.
</br>• الاستئذان قبل الطباعة.`,
    fr: `Le CDI est un Centre de Documentation et d’Information. 
Les élèves peuvent
</br>• Lire pour le plaisir : romans, poésie, pièce de théâtre, Bande Dessinée, œuvres classiques etc.
</br>- Faire un travail de recherche, en utilisant le logiciel de recherche documentaire et les ouvrages documentaires.
</br>• Produire des documents.
</br>• Enrichir leur culture personnelle en lisant des documents de culture.
</br>• S’informer en lisant les périodiques, la presse et les panneaux d’affichages.
</br>• Consulter les documents qui s’y trouvent et utiliser les usuels : dictionnaires, encyclopédies papier et électronique, atlas, manuels scolaires.
</br>• Venir au C.D.I. avec un professeur dans le cadre d’une heure de cours.
</br>• utiliser les ordinateurs pour consulter les cdroms, mettre en forme du texte (WORD, EXCEL…) et se connecter à Internet dans le cadre des recherches encadrées.
</br>Les élèves doivent
</br>• Respecter le personnel du CDI et dire bonjour aux enseignantes documentalistes.
</br>• Déposer les sacs en entrant et ne prendre que les affaires nécessaires au travail.
</br>• Ne pas amener de boissons ou de nourriture.
</br>• S’inscrire sur la fiche de présence.
</br>• Être silencieux ou parler à voix basse.
</br>• Prendre soin du mobilier, des documents et du matériel.
</br>• Respecter le classement des documents car tout document a sa place.
</br>• venir au bureau des enseignantes documentalistes pour rendre ou emprunter un document.
</br>• Faire un travail qui nécessite l’utilisation de documents du CDI.
</br>• Ranger chaises et tables avant de quitter le CDI.
</br>• Demander l’autorisation aux enseignantes documentalistes avant d’utiliser les ordinateurs.
</br>• S’inscrire sur la fiche d’utilisation des ordinateurs.
</br>• Ne pas consulter des boîtes aux lettres, des blogs, des sites de société et autres sites illicites.
</br>• Ne pas chater sauf dans le cadre d’un clavardage scolaire.
</br>• Ne pas faire des jeux sur les ordinateurs.
</br>• Ne pas utiliser les clés USB et demander aux enseignantes documentalistes de scanner CD – DVD …. avant de les utiliser.
</br>• Demander l’autorisation avant toute impression.`,
    en: `Internal Regulations of the french library:
Students can: 
</br>• Read for pleasure: novels, poetry, plays, comics, classic works, etc.
</br>• Conduct research using the documentary search software and reference books.
</br>• Produce documents.
</br>• Enrich their personal culture by reading cultural documents.
</br>• Stay informed by reading periodicals, the press, and bulletin boards.
</br>• Consult the documents available and use reference materials: dictionaries, paper and electronic encyclopedias, atlases, textbooks.
</br>• Come to the C.D.I. with a teacher during a class hour.
</br>• Use computers to access CD-ROMs, format text (WORD, EXCEL…), and connect to the Internet for guided research.
</br>Students must:
</br>• Respect the C.D.I. staff and greet the librarian teachers.
</br>• Leave bags at the entrance and only bring necessary items for work.
</br>• Not bring drinks or food.
</br>• Sign the attendance sheet.
</br>• Remain silent or speak quietly.
</br>• Take care of the furniture, documents, and equipment.
</br>• Respect the organization of documents because every document has its designated place.
</br>• Go to the librarian’s office to return or borrow a document.
</br>• Do work that requires the use of C.D.I. documents.
</br>• Arrange chairs and tables before leaving the C.D.I.
</br>• Ask for permission from the librarian teachers before using the computers.
</br>• Sign the computer usage log.
</br>• Not access mailboxes, blogs, social sites, or any illegal websites.
</br>• Not chat except for school-related messaging.
</br>• Not play games on the computers.
</br>• Not use USB.
</br>• Ask for permission before printing.`,
  },
  order: 0,
  attachments: [], //TODO : Attach CDI FR 2025.png
  image: 'CDI_FR_2025.png',
  type: 'academics/library/fr',
  isArchived: false,
};
